SiteObjectifValidator.$inject = ['validator'];

export default function SiteObjectifValidator(validator) {
    const instance = new validator();

    return instance;
}
